/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailMasked
 */
export interface EmailMasked {
    /**
     * A masked email address, to preserve privacy
     * @type {string}
     * @memberof EmailMasked
     */
    email: string;
}

export function EmailMaskedFromJSON(json: any): EmailMasked {
    return EmailMaskedFromJSONTyped(json, false);
}

export function EmailMaskedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailMasked {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function EmailMaskedToJSON(value?: EmailMasked | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}


